/**
 * JS entry point of project
 * @see https://abs-group.atlassian.net/wiki/spaces/GD/pages/86867986
 */

// Global dependencies
import Alpine from 'alpinejs';
window.Alpine = global.Alpine = Alpine;

// Common scripts
import './import/common.js';
import './import/phoneinput.js';
import './import/widgets.js';

// Common components
import "@/_components/map/_";
import "@/_components/popups/_";
import "@/_components/footer/_";
import "@/_components/model-navigation/_";
import "@/_components/menu-mobile/_";
import "@/_components/nav-mobile/_";
import "@/_components/favorites/_";

// General code
